/* eslint-disable @typescript-eslint/no-unused-vars */
import '@tanstack/react-table' //or vue, svelte, solid, qwik, etc.
import { Row } from '@tanstack/react-table'

declare module '@tanstack/react-table' {
  interface ColumnMeta<TData, TValue> {
    /**
     * Tailwind classes appended to every body `<td>` in this column via
     * `twMerge`. Use this to set a per-column background (e.g. highlight
     * a "Most popular" pricing column). Passing `bg-*` here will override
     * the default `bg-white` on each body cell. Hover / row-selection
     * styles still take precedence because they're flagged with `!`.
     */
    bodyCellClassName?: string
    dangerouslyOverrideHorizontalPadding?: React.CSSProperties['paddingLeft']
    /**
     * Tailwind classes appended to this column's header cell via
     * `twMerge`. Use this for per-column header styling such as a
     * matching background to a highlighted body column, or to clear the
     * default `bg-neutral-100` strip (pass `bg-transparent`). Passing
     * `bg-*` here overrides the default header background since twMerge
     * collapses conflicting background utilities.
     */
    headerCellClassName?: string
    minWidth?: React.CSSProperties['minWidth']
    onClick?: (e: React.MouseEvent<HTMLTableCellElement>, row: Row<TData>) => void
    shouldRenderHeaderAsTd?: boolean
    stickiness?: TableCellStickiness
    textAlign?: React.CSSProperties['textAlign']
    width?: React.CSSProperties['width']
  }
}

export enum TableColumnId {
  Expand = 'govwell-table-expansion-column',
  Reorder = 'govwell-table-drag-handler-column',
  Select = 'govwell-table-selection-column',
}

export interface TableRowDragState<TData> extends Record<string | symbol, unknown> {
  tableUuid: string
  row: Row<TData>
}
export interface TableDropTargetDragState extends Record<string | symbol, unknown> {
  isTableDropTarget: true
  tableUuid: string
}

export type TableCellStickiness = 'left' | 'right' | 'none'
